import styles from "./BurgerMenu.mobile.module.css";
import type BurgerMenuProperties from "../BurgerMenu.properties.ts";

export default function BurgerMenuMobileView(props: BurgerMenuProperties) {
  return (
    <div className={styles.menu}>
      <ul className={styles.menuItems}>
        {props.items.map((item, index) => (
          <li key={index} className={styles.menuItem}>
            {item.child}
          </li>
        ))}
      </ul>
    </div>
  );
}
